import React from 'react';
import { Spinner, Button } from 'react-bootstrap';
import { ListColumn } from '../Datalist/Datalist'; // Import your Datalist component
import Datalist from '../Datalist/Datalist';
import { useNavigate } from 'react-router-dom';
import './EmailTemplateTable.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

interface EmailTemplate {
    id: number;
    templateName: string;
    header: string;
    body: string;
    active: boolean;
}

interface EmailTemplateTableProps {
    templates: EmailTemplate[];
    isLoading: boolean;
    onDelete: (id: number) => void;
}

const EmailTemplateTable: React.FC<EmailTemplateTableProps> = ({ templates, isLoading, onDelete }) => {
    const navigate = useNavigate();

    // Define the columns for the Email Template table
    const columns: ListColumn<EmailTemplate>[] = React.useMemo(() => [
        {
            key: 'templateName',
            fieldName: 'templateName',
            name: 'Mallnamn', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: EmailTemplate) => item.templateName,
            footer: (items: EmailTemplate[]) => `Totalt antal mallar: ${items.length}`, // Translated
        },
        {
            key: 'header',
            fieldName: 'header',
            name: 'E-postämne', // Translated to Swedish
            minWidth: 200,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: EmailTemplate) => item.header,
        },
        {
            key: 'active',
            fieldName: 'active',
            name: 'Aktiv', // Translated to Swedish
            minWidth: 100,
            isActive: true,
            onRender: (item: EmailTemplate) => (
                item.active ? (
                    <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green', fontSize: '1.3rem' }} />
                ) : (
                    <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red', fontSize: '1.3rem' }} />
                )
            ),
        },
        {
            key: 'actions',
            fieldName: 'actions',
            name: 'Åtgärder', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            onRender: (item: EmailTemplate) => (
                <div className="button-group-email-template">
                    <button className="warning btn" onClick={() => navigate(`/email-templates/edit/${item.id}`)}>
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button className="danger button-danger btn" onClick={() => onDelete(item.id)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            ),
        }
    ], [templates, navigate, onDelete]);

    return (
        <div className="email-template-table-wrapper" style={{ maxHeight: '600px', overflowY: 'auto' }}>
            <Datalist
                items={templates}
                isLoading={isLoading}
                columns={columns}
                setColumns={(updatedColumns: ListColumn<EmailTemplate>[]) => {
                    console.log('Columns updated:', updatedColumns);
                }}
                initialSortKey="templateName"  // Set default sort column
                descendingSort={false}    // Set default sort order to ascending
                noItemsText="Inga e-postmallar tillgängliga" // Translated
                uniqueKey="id"  // Use 'id' as the unique key
            />
        </div>
    );
};

export default EmailTemplateTable;
